import Popper from '@material-ui/core/Popper';
import clsx from 'clsx';
import React from 'react';

import ClickAwayListener from '@/src/components/common/ClickAwayListener/ClickAwayListener';

import Option from '../Option/Option';

const Options = ({
  options,
  tags,
  refs,
  showOptions,
  hasMore,
  onSelectOption,
  onPopperClickAway,
}) => {
  const { containerRef, popperRef, lastElementRef } = refs;

  if (!showOptions || options.length < 1) {
    return null;
  }

  return (
    <React.Fragment>
      <div ref={popperRef}>
        <Popper
          open={true}
          anchorEl={containerRef.current}
          placement="bottom-start"
          style={{ zIndex: 9999 }}
          disablePortal={true}
        >
          <ClickAwayListener onClickAway={onPopperClickAway}>
            <div
              className={clsx(
                'container--tagOptions',
                'tw-min-w-[600px] tw-max-h-[250px]',
                'tw-overflow-y-auto tw-scroll-styles',
                'tw-border-solid tw-border-[1px] tw-border-cfo-grey-500 tw-rounded-b-[3px]',
                'tw-shadow-[3px_4px_4px_rgb(0_0_0_/_6%)] tw-bg-white',
                'tw-mt-[5px] tw-ml-0'
              )}
            >
              {options.map((option, index) => {
                return (
                  <Option
                    key={`${option.value}_${index}`}
                    tags={tags}
                    option={option}
                    onSelectOption={onSelectOption}
                  />
                );
              })}
              {hasMore && <div ref={lastElementRef} className="spinner"></div>}
            </div>
          </ClickAwayListener>
        </Popper>
      </div>
    </React.Fragment>
  );
};

export default Options;
